<template>
	<!-- Main div wrapper -->
	<div>

<!--		<div v-if="checkUserPermissionInFinjaLoading === false && pmsView === true">-->

			<div id="companyRegisteredAndPackageNotExpired" v-if="checkCompanyRegisterationInFinjaLoading === false && isCompanyRegisteredInFinja === true && isCompanyRegisterationExpiredInFinja === false">

				<template>
						
					<iframe id="companyRegisteredAndPackageNotExpiredAndUserLoggedIn" v-if="loginUserInPmsLoading === false && isUserRegisteredInPms === true" :src="iframeLink" style="width: 100% !important; height: 90vh; border: none; margin: 0; padding: 0; overflow: hidden; z-index: 999999;"></iframe>

					<preLoader v-else-if="loginUserInPmsLoading === true"></preLoader>

				</template>
				
			</div>
		
			<preLoader v-else-if="checkCompanyRegisterationInFinjaLoading === true"></preLoader>

			<div id="companyRegisteredButPackageExpired" v-else-if="checkCompanyRegisterationInFinjaLoading === false && isCompanyRegisteredInFinja === true && isCompanyRegisterationExpiredInFinja === true && isUserRegisteredInPms === false && pmsPayment === true">
				<pmsPackagePricingComponent @registerCompanyInPms="registerCompanyInPms" :pmsPaymentPermission="pmsPayment"></pmsPackagePricingComponent>
			</div>
			
			<div id="companyNotRegistered" v-else-if="checkCompanyRegisterationInFinjaLoading === false && isCompanyRegisteredInFinja === false && isCompanyRegisterationExpiredInFinja === true && isUserRegisteredInPms === false && pmsPayment === true">
				<pmsPackagePricingComponent  @registerCompanyInPms="registerCompanyInPms" :pmsPaymentPermission="pmsPayment"></pmsPackagePricingComponent>
			</div>

<!--		</div>-->
		
		<preLoader v-else-if="checkUserPermissionInFinjaLoading === true"></preLoader>

<!--		<notAllowed v-if="checkUserPermissionInFinjaLoading === false && pmsView === false"></notAllowed>-->

    <notAllowed v-if="checkUserPermissionInFinjaLoading === true && pmsPayment === false"></notAllowed>

    </div>


</template>

<script>

import pmsPackagePricingComponent from './pmsPackagePricingComponent';
		
export default {
	components: {
		pmsPackagePricingComponent
	},
  	data() {
		return {
			iframeLink: null,
			
			pmsView : false,
			pmsPayment : false,

			checkUserPermissionInFinjaLoading : true,
			checkCompanyRegisterationInFinjaLoading : true,
			registerCompanyInPmsLoading : true,
			loginUserInPmsLoading : true,

			isCompanyRegisteredInFinja : false,
			isCompanyRegisterationExpiredInFinja : true,

			isCompanyRegisteredInPms : false,

			isUserRegisteredInPms : false,

			pmsEmailRedirectionUrl : null,
			isEmployee : false,
		}
	},
	beforeMount : function()
	{
		this.pmsEmailRedirectionUrl = this.$route.query.url ? this.$route.query.url : null;  

		this.checkUserPermissionInFinja();

		this.checkPaymentPermission();
	},
	methods: 
	{
		checkPaymentPermission : function() {
			this.can('pms_payment')
				.then(result => {

					this.pmsPayment = result.pms_payment;


					if(this.pmsPayment === false)
					{
						this.checkUserPermissionInFinjaLoading = false;
					}

				})
				.catch(err => {
					console.log(err);

					this.checkUserPermissionInFinjaLoading = false;
					this.$Progress.finish();

					this.showAlertBox('error', 'Error', 'Something Went Wrong While Checking User Permissions !');
				});
		},

		// checkUserPermissionInFinja : function()
		// {
		// 	this.$Progress.start();
		//
		// 	this.checkUserPermissionInFinjaLoading = true;
		//
		// 	this.can('pms_view|pms_payment')
		// 	.then(result => {
		//
		// 		console.log(this.$global);
		//
		// 		this.pmsView = result.pms_view;
		// 		this.pmsPayment = result.pms_payment;
		//
		// 		this.checkUserPermissionInFinjaLoading = false;
		// 		this.$Progress.finish();
		//
		// 		if(this.pmsView)
		// 		{
		// 			this.checkCompanyRegisterationInFinja();
		// 		}
		//
		// 	})
		// 	.catch(err => {
		// 		console.log(err);
		//
		// 		this.checkUserPermissionInFinjaLoading = false;
		// 		this.$Progress.finish();
		//
		// 		this.showAlertBox('error', 'Error', 'Something Went Wrong While Checking User Permissions !');
		// 	});
		// },

		checkUserPermissionInFinja : function()
		{
			// this.$Progress.start();

			this.checkUserPermissionInFinjaLoading = true;

			// this.can('pms_view|pms_payment')
			// 		.then(result => {

						console.log(this.$global);

						// this.pmsView = result.pms_view;
						// this.pmsPayment = result.pms_payment;

						// this.checkUserPermissionInFinjaLoading = false;
						// this.$Progress.finish();

						// if(this.pmsView)
						// {
							this.checkCompanyRegisterationInFinja();
						// }

					// })
					// .catch(err => {
					// 	console.log(err);

						// this.checkUserPermissionInFinjaLoading = false;
						// this.$Progress.finish();

						// this.showAlertBox('error', 'Error', 'Something Went Wrong While Checking User Permissions !');
					// });
		},


		checkCompanyRegisterationInFinja: function()
		{
			this.$Progress.start();

			this.checkCompanyRegisterationInFinjaLoading = true;

			axios.post('/api/pms/checkCompanyRegistration')
			.then((res) => {
				if(res.data.status == 200)
				{
					console.log(res.data);

					if(res.data.data === 'COMPANY_REGISTERED')
					{
						this.isCompanyRegisteredInFinja = true;
						this.isCompanyRegisterationExpiredInFinja = false;
						this.checkCompanyRegisterationInFinjaLoading = false;
						this.$Progress.finish();

						this.loginUserInPms();
					}
					else if(res.data.data === 'COMPANY_REGISTERATION_EXPIRED')
					{
						this.isCompanyRegisteredInFinja = true;
						this.isCompanyRegisterationExpiredInFinja = true;
						this.checkCompanyRegisterationInFinjaLoading = false;
						this.$Progress.finish();

						this.showAlertBox('info', 'Company Registration Expired !');
					}
					else if(res.data.data === 'COMPANY_NOT_REGISTERED')
					{
						this.isCompanyRegisteredInFinja = false;
						this.isCompanyRegisterationExpiredInFinja = true;
						this.checkCompanyRegisterationInFinjaLoading = false;
						this.$Progress.finish();

						this.showAlertBox('info', 'Company Is Not Subscribed To Package !');
					}
				}
				else
				{
					console.log(res.data);
					
					this.isCompanyRegisteredInFinja = false;
					this.isCompanyRegisterationExpiredInFinja = true;

					this.checkCompanyRegisterationInFinjaLoading = false;
					this.$Progress.finish();

					this.showAlertBox('info', 'Something Went Wrong While Checking Company Registration In Finja !');
				}
			})
			.catch((err) => {
				console.log(err);
					
				this.isCompanyRegisteredInFinja = false;
				this.isCompanyRegisterationExpiredInFinja = true;

				this.checkCompanyRegisterationInFinjaLoading = false;
				this.$Progress.finish();

				this.showAlertBox('info', 'Something Went Wrong While Checking Company Registration In Finja !!');
			});
		},


		registerCompanyInPms : function()
		{
			this.$Progress.start();

			this.registerCompanyInPmsLoading = true;

			axios.post('/api/pms/registerCompanyInPms')
			.then((res) => {

				console.log(res.data);

				if(res.data.status == 200)
				{
					if(res.data.data === 'COMPANY_REGISTERATION_SUCCESS')
					{
						this.isCompanyRegisteredInFinja = true;
						this.isCompanyRegisterationExpiredInFinja = false;

						this.isCompanyRegisteredInPms = true;
						this.registerCompanyInPmsLoading = false;
						this.$Progress.finish();

						this.loginUserInPms();
					}
					else if(res.data.data === 'COMPANY_ALREADY_EXIST')
					{
						this.isCompanyRegisteredInFinja = true;
						this.isCompanyRegisterationExpiredInFinja = false;

						this.isCompanyRegisteredInPms = true;
						this.registerCompanyInPmsLoading = false;
						this.$Progress.finish();

						this.loginUserInPms();
					}
					else // COMPANY_REGISTERATION_FAIL
					{
						this.isCompanyRegisteredInPms = false;
						this.registerCompanyInPmsLoading = false;
						this.$Progress.finish();

						this.showAlertBox('error', 'Company Registration Failed In Performance Management System !');
					}
				}
				else
				{
					this.isCompanyRegisteredInPms = false;
					this.registerCompanyInPmsLoading = false;
					this.$Progress.finish();

					this.showAlertBox('error', 'Company Registration Failed In Performance Management System !!');
				}
			})
			.catch((err) => {
				this.isCompanyRegisteredInPms = false;
				this.registerCompanyInPmsLoading = false;
				this.$Progress.finish();

				this.showAlertBox('error', 'Company Registration Failed In Performance Management System !!!');
			});
		},
		

		loginUserInPms : function()
		{
			this.$Progress.start();

			let formData = {
				pmsEmailRedirectionUrl: this.pmsEmailRedirectionUrl 
			};

			this.loginUserInPmsLoading = true;

			axios.post('/api/pms/loginUserInPms', formData)
			.then((res) => {

				console.log(res.data);

				if(res.data.status == 200)
				{
					if(res.data.data.reason === 'USER_LOGGED_IN')
					{
						this.iframeLink = res.data.data.loginUrl;
						this.isUserRegisteredInPms = true;
						this.loginUserInPmsLoading = false;
						this.$Progress.finish();
					}
					else if(res.data.data.reason === 'USER_DOES_NOT_EXIST')
					{
						this.isUserRegisteredInPms = false;
						this.loginUserInPmsLoading = false;
						this.$Progress.finish();

						this.showAlertBox('error', 'User does not exist in Performance Management System');
					}
					else // USER_LOGIN_FAIL and Any other reason
					{
						this.isUserRegisteredInPms = false;
						this.loginUserInPmsLoading = false;
						this.$Progress.finish();

						this.showAlertBox('error', 'User Login failed in Performance Management System !');
					}
				}
				else
				{
					this.isUserRegisteredInPms = false;
					this.loginUserInPmsLoading = false;
					this.$Progress.finish();

					this.showAlertBox('error', 'User Login failed in Performance Management System !!');
				}
			})
			.catch((err) => {
				this.isUserRegisteredInPms = false;
				this.loginUserInPmsLoading = false;
				this.$Progress.finish();

				this.showAlertBox('error', 'User Login failed in Performance Management System !!!');
			});
		},
	}
};
</script>